import React from "react";
import {useOpenSeaDragonViewer} from "../OpenSeaDragonViewer/useOpenSeaDragonViewer";
import {alpha, Box, IconButton, Popover} from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import OpenSeaDragonViewer from "../OpenSeaDragonViewer/OpenSeaDragonViewer";
import {makeStyles} from "@mui/styles";
import PropTypes from "prop-types";

const useStyles = makeStyles((theme) => ({
    popoverRoot: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginLeft: props => props.marginLeft,
    },
    button: {
        color: 'red'
    }
}));

export default function ImagePreview(props) {
    const classes = useStyles(props);
    const {image} = props;
    const [open, setOpen] = React.useState(false);
    // eslint-disable-next-line no-unused-vars
    const {viewer, initViewer} = useOpenSeaDragonViewer(`preview-${image.title}`, `${image.src}/info.json`, {
        id: `preview-${image.title}`,
        showNavigationControl: false,
        tileSources: [{
            tileSource: `${image.src}/info.json`,
            x: 0.0,
            y: 0.0,
            width: 1
        }]
    });
    const [isInPreview, setIsInPreview] = React.useState(false);

    const togglePointerIn = () => {
        setIsInPreview(!isInPreview);
    }

    const handleClick = () => {
        setOpen(true);
    };

    const handleClose = () => {
        if (!isInPreview)
            setOpen(false);
    };

    const id = open ? image.title : undefined;

    return (
        <div>
            <IconButton
                aria-describedby={id}
                aria-label={`info about ${image.title}`}
                onClick={handleClick}
                sx={{
                    color: props.color ? props.color : theme => theme.palette.text.primary,
                    bgcolor: alpha("#000", 0.2)
                }}
            >
                <VisibilityIcon/>
            </IconButton>
            <Popover
                id={id}
                open={open}
                onClose={handleClose}
                PaperProps={{onPointerEnter: togglePointerIn, onPointerLeave: togglePointerIn}}
                onWheel={handleClose}
                anchorReference={"none"}
                classes={{
                    root: classes.popoverRoot,
                }}
            >
                <Box width={window.innerWidth * 0.8} maxWidth="800px">
                    <OpenSeaDragonViewer
                        viewer={viewer}
                        viewerID={`preview-${image.title}`}
                        init={initViewer}
                        showSpeedDial={false}
                        height="90vh"
                    />
                </Box>
            </Popover>
        </div>
    );
}

ImagePreview.propTypes = {
    image: PropTypes.shape({
            src: PropTypes.string.isRequired,
            collection: PropTypes.string,
            title: PropTypes.string.isRequired,
            format: PropTypes.string,
            width: PropTypes.number,
            height: PropTypes.number,
        }
    ).isRequired
}